$(document).on('click', '.copy-id', function () {
    var $el = $(this);
    if ($el.hasClass('copied')) return;

    var id = $el.find('span').first().text().trim();
    var originalHtml = $el.html();

    navigator.clipboard.writeText(id).then(function () {
        $el.addClass('copied');
        $el.html('<svg><use href="/assets/plus-theme/images/sprite/symbol-defs.svg#icon-check"></use></svg> Copiat');

        setTimeout(function () {
            $el.removeClass('copied');
            $el.html(originalHtml);
        }, 2000);
    });
});
